(() => {
  if (window.__olivineIngredientesTextoBound) return;
  window.__olivineIngredientesTextoBound = true;

  const setOpen = (root, open) => {
    const panel = root.querySelector('[data-ingredientes-texto-panel]');
    const openBtn = root.querySelector('[data-ingredientes-texto-open]');
    if (!panel || !openBtn) return;

    openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');

    if (open) {
      panel.hidden = false;
      // Forzar reflow para que la transición 0fr → 1fr se anime
      void panel.offsetHeight;
      root.classList.add('is-open');
      return;
    }

    root.classList.remove('is-open');

    const hidePanel = () => {
      if (!root.classList.contains('is-open')) {
        panel.hidden = true;
      }
    };

    const onEnd = (event) => {
      if (event.target !== panel) return;
      if (event.propertyName !== 'grid-template-rows' && event.propertyName !== 'opacity') return;
      panel.removeEventListener('transitionend', onEnd);
      hidePanel();
    };

    panel.addEventListener('transitionend', onEnd);
    setTimeout(hidePanel, 500);
  };

  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-ingredientes-texto-open]');
    if (openBtn) {
      const root = openBtn.closest('[data-ingredientes-texto]');
      if (!root) return;
      setOpen(root, true);
      return;
    }

    const closeBtn = event.target.closest('[data-ingredientes-texto-close]');
    if (!closeBtn) return;
    const root = closeBtn.closest('[data-ingredientes-texto]');
    if (!root) return;
    setOpen(root, false);
  });
})();
